export const USER_PERMISSIONS = {
  IS_PERMISSIONS_ADMIN: 'is_permissions_admin',
  IS_HUB_ADMIN: 'is_hub_admin',
  CAN_MANAGE_AREAS: 'can_manage_areas',
  CAN_MANAGE_ROLES: 'can_manage_roles',
  IS_STAFF: 'is_staff',
  HAS_ACTIVE_DEMOCRACY_PROCESS: 'has_active_democracy_process',
  CAN_MANAGE_LEVIES: 'can_manage_levies',
  CAN_MANAGE_ORGANISERS: 'can_manage_organisers',
} as const
